<template>
  <div>
    <h1>{{$t("datos_factura.titulo")}}</h1>
    <div class="mensaje-informativo">
      <i class="fa fa-regular fa-info-circle"></i>
      <span v-html="$t('datos_factura.form.mensaje_informativo')"></span>
    </div>
    <DxForm id="formularioFactura" ref="formInstance" :form-data="model" label-location="top"
      :show-colon-after-label="false" :visible="model != null" validation-group="validacionFactura">
      <!-- xs: 768, sm: 992, md:1200 -->
      <DxColCountByScreen :xs="12" :sm="12" :md="12" :lg="12" />

      <!-- Datos de la factura -->
      <DxGroupItem :col-count="12" :col-span="12">
        <DxSimpleItem data-field="CodigoGestionadoPorColaborador" editor-type="dxCheckBox" :col-span="3">
          <DxLabel :text="$t('datos_factura.form.gestionado_por_colaborador')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="CodigoBorrador" editor-type="dxTextBox" :col-span="3" :editor-options="soloLecturaSiNoGestionadoPorColaborador">
          <DxLabel :text="$t('datos_factura.form.codigo_borrador')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.codigo_borrador')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="FechaEmision" editor-type="dxDateBox" :editor-options="soloLecturaSiAutofactura" :col-span="3" >
          <DxLabel :text="$t('datos_factura.form.fecha_emision')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.fecha_emision')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="FechaAlta" editor-type="dxDateBox" :editor-options="soloLecturaSiAutofactura" :col-span="3" >
          <DxLabel :text="$t('datos_factura.form.fecha_registro')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.fecha_registro')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="NombreEmisor" editor-type="dxTextBox" :editor-options="soloLecturaSiAutofactura" :col-span="4">
          <DxLabel :text="$t('datos_factura.form.nombre_emisor')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.nombre_emisor')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="NifEmisor" editor-type="dxTextBox" :editor-options="soloLecturaSiAutofactura" :col-span="3" >
          <DxLabel :text="$t('datos_factura.form.nif')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.nif')" />
          <DxPatternRule :pattern="dniNieNifPattern" :message="$t('datos_factura.form.validacion.nif_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="IbanEmisor" editor-type="dxTextBox" :col-span="5" :editor-options="ibanOptions">
          <DxLabel :text="$t('datos_factura.form.iban_emisor')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.iban_emisor')" />
        </DxSimpleItem>
      </DxGroupItem>

      <!-- Dirección del emisor -->
      <DxGroupItem :col-count="12" :col-span="12">
        <DxSimpleItem data-field="DireccionEmisor.CodigoPostal" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('datos_factura.form.codigo_postal')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.codigo_postal')" />
          <DxPatternRule :pattern="codigoPostalPattern"
            :message="$t('datos_factura.form.validacion.codigo_postal_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.Provincia" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="4">
          <DxLabel :text="$t('datos_factura.form.provincia')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.provincia')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.Municipio" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="6">
          <DxLabel :text="$t('datos_factura.form.municipio')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.municipio')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.TipoVia" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="4">
          <DxLabel :text="$t('datos_factura.form.tipo_de_via')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.tipo_de_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.NombreVia" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="8">
          <DxLabel :text="$t('datos_factura.form.nombre_via')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.nombre_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.Numero" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('datos_factura.form.numero')" />
          <DxRequiredRule :message="$t('datos_factura.form.validacion.numero')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.Escalera" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('datos_factura.form.escalera')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.Piso" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('datos_factura.form.piso')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="DireccionEmisor.Puerta" :editor-options="soloLecturaSiAutofactura" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('datos_factura.form.puerta')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="4">
        </DxEmptyItem>
      </DxGroupItem>

      <!-- Cálculo de impuestos -->
      <DxGroupItem :col-count="1" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{
            $t("datos_factura.form.calculo_impuestos")
          }}</span>
        </DxSimpleItem>
        <DxSimpleItem editor-type="dxNumberBox" :editor-options="baseImponibleOptions">
          <DxLabel location="left" alignment="left" :text="$t('datos_factura.form.base_imponible')" />
        </DxSimpleItem>
        <DxSimpleItem editor-type="dxNumberBox" :editor-options="ivaOptions">
          <DxLabel location="left" alignment="left" :text="$t('datos_factura.form.impuesto_iva')" />
        </DxSimpleItem>
        <DxSimpleItem editor-type="dxNumberBox" :editor-options="irpfOptions">
          <DxLabel location="left" alignment="left" :text="labelImpuestoIRPF" />
        </DxSimpleItem>
        <DxSimpleItem editor-type="dxNumberBox" :editor-options="totalOptions">
          <DxLabel location="left" alignment="left" :text="$t('datos_factura.form.total_factura')" />
        </DxSimpleItem>
      </DxGroupItem>

      <!-- Notas -->
      <DxSimpleItem data-field="Notas" editor-type="dxTextArea" :col-span="6" :editor-options="{height: 220}">
        <DxLabel :text="$t('datos_factura.form.notas')" />
      </DxSimpleItem>

      <!-- Botones -->
      <DxGroupItem :col-count="12" :col-span="12">
        <DxEmptyItem :col-span="4"></DxEmptyItem>
        <DxButtonItem :col-span="4" :button-options="optGenerarDescargarFactura" ></DxButtonItem> 
        <DxButtonItem :col-span="4" :button-options="optVerificarFactura" ></DxButtonItem> 
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script setup lang="ts">
import {
  DxForm,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxPatternRule,
  DxEmptyItem,
  DxGroupItem,
  DxButtonItem,
  DxSimpleItem
} from "devextreme-vue/form";
import {  computed, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { useIntl } from '@services/i18n';
import validationEngine from "devextreme/ui/validation_engine";
import { useApi } from '@api/integration';
import { toastError, toastSuccess } from '@/.shared/services/notification-service';
import { primaryButtonProps } from "@/.shared/helpers/button-helper";
import { CreateFactura } from "./models/CreateFactura";
import type { CreateFacturaModel } from "@/.shared/.api";
import { saveAs } from 'file-saver';
import { ApiError } from "@/.shared/services/http";
import { INVOICE_MISSING_DECOMMISSION_OPERATIONS, INVOICE_WITH_DUPLICATED_CODE } from "@/.shared/errors/codes";
import { getIbanOptions } from "@/.shared/helpers/text-box-helper";
import { useModalService } from "@/.shared/services/modal-service";
import VerificarFacturaModal, { type VerificarFacturaModalResult } from "@/components/liquidaciones/VerificarFacturaModal.vue";
import { messageBoxResult } from "@components/dialogs/message-box";
import { CreateTicket } from "@/.shared/components/soporte/models/CreateTicket";
import { importeLineaLiquidacionParaBaseImponible } from "@helpers/retribucion-economica-helper";

const api = useApi();
const formInstance = ref<DxForm>();
const intl = useIntl();
const model = reactive<CreateFactura>(new CreateFactura());
const isFormValid = ref(false);
const facturaGenerada = ref(false);
const PORCENTAJE_IVA = 0.21;

const ibanPattern = ref<RegExp>(/^ES\d{22}$/);
const dniNieNifPattern = ref<RegExp>(/(^\d{8}[A-Za-z]$)|(^[A-Za-z]\d{7}[A-Za-z0-9]$)/);
const codigoPostalPattern = ref<RegExp>(/^\d{5}$/);

const modalService = useModalService();

const emit = defineEmits(['facturaCreada']);

const props = defineProps({
  esAutofactura: {
    type: Boolean,
    default: false
  },
  liquidacionesSeleccionadas: {
    type: Array,
    default: []
  },
  rappelsSeleccionados: {
    type: Array,
    default: []
  },
});

onMounted(async () => {
  model.createFromConfigFactura(await api.callStandardApi("getNextFacturaConfig", {showLoading: false}));
});

const precioNumberOptions = {
  showSpinButtons: false,
  step: 0.01,
  format: {
    type: "fixedPoint",
    precision: 2,
    formatter: (value: number) => {
      return intl.i18n.n(Number(value.toFixed(2)), 'decimal') + ' €';
    }
  },
  disabled: true
}

const soloLecturaSiAutofactura = {
  readOnly: props.esAutofactura
}

const soloLecturaSiNoGestionadoPorColaborador = computed(() => {
  return {
  readOnly: !model.CodigoGestionadoPorColaborador
}});

const handleIbanValueChanged = (e: any) => {
  const upperValue = e.value?.toUpperCase().replace(/ /g, "");
  model.IbanEmisor = upperValue
    ? `ES${upperValue.replace(/^ES/, '')}`
    : '';
};

const ibanOptions = {
  ...getIbanOptions(),
  readOnly: props.esAutofactura,
  onValueChanged: handleIbanValueChanged
};

const labelImpuestoIRPF = computed(() => {
  const irpf = model.IrpfEmpresa ?? 0.0 
  return `${intl.i18n.t('datos_factura.form.impuesto_irpf')} (${irpf}%)`;
});

const baseImponible = computed(() => {
  let baseLiquidaciones = props.liquidacionesSeleccionadas.reduce(
    (total: number, liquidacion: any) => total + importeLineaLiquidacionParaBaseImponible(liquidacion),
    0,
  );

  let baseRappels = props.rappelsSeleccionados.reduce((total: number, rappel: any) => {
    return total + (rappel.ComisionTotal || 0);
  }, 0);

  return baseLiquidaciones + baseRappels;
});

const impuestosIva = computed(() => {
  return (baseImponible.value > 0) ? baseImponible.value * PORCENTAJE_IVA : 0
})

const impuestosIrpf = computed(() => {
  return (baseImponible.value > 0) ? -(baseImponible.value * ((model.IrpfEmpresa ?? 0.0) / 100)) : 0
})

const baseImponibleOptions = computed(() => { return {
  ...precioNumberOptions,
  value: baseImponible.value
}});

const ivaOptions = computed(() => { return {
  ...precioNumberOptions,
  value: impuestosIva.value
}});

const irpfOptions = computed(() => { return {
  ...precioNumberOptions,
  value: impuestosIrpf.value
}});

const totalOptions = computed(() => { return {
  ...precioNumberOptions,
  value: baseImponible.value + impuestosIva.value + impuestosIrpf.value
}});

const esGenerarDisabled = computed(() => {
  return !model || !isFormValid.value || baseImponible.value < 0 || (baseImponible.value == 0 && props.liquidacionesSeleccionadas.length == 0 && props.rappelsSeleccionados.length == 0);
});

const esVerificarDisabled = computed(() => {
  return !model || !isFormValid.value || baseImponible.value < 0 || (baseImponible.value == 0 && props.liquidacionesSeleccionadas.length == 0 && props.rappelsSeleccionados.length == 0) || !facturaGenerada.value;
});

watch(model, async (_newValue, _oldValue) => {
  await nextTick(() => {
    isFormValid.value = validationEngine.validateGroup("validacionFactura").isValid ?? false;
    facturaGenerada.value = false;
  });
}, { deep: true });

watch(totalOptions, async (_newValue, _oldValue) => {
  await nextTick(() => {
    isFormValid.value = validationEngine.validateGroup("validacionFactura").isValid ?? false;
    facturaGenerada.value = false;
  });
}, { deep: true });

const generarYDescargarFactura = async () => {
  var res = validationEngine.validateGroup("validacionFactura");

  if (res.isValid) {
    model.Liquidaciones = props.liquidacionesSeleccionadas.map(r => ({
      IdTramite: (r as any).IdTramite,
      IdServicioIncluido: (r as any).IdServicioIncluido,
    }));
    model.RappelsMensuales = props.rappelsSeleccionados.map(r => (r as any).Id);

    try {
      await api.callStandardApi("generateBorradorFactura", {}, model as CreateFacturaModel, {responseType: "blob", extensions: {}})
        .then((data: any) => {
          saveAs(data, "BorradorFactura.pdf")
        });

      facturaGenerada.value = true;
      return true;
    }
    catch(e: any){
      
    }
    
  } else {
    toastError(intl.i18n.t('datos_factura.form.revise_validacion'));
  }
}

const verificarFactura = async () => {
  const res = validationEngine.validateGroup("validacionFactura");

  if (!res.isValid) {
    toastError(intl.i18n.t('datos_factura.form.revise_validacion'));
    return;
  }

  const modalResult = (await modalService.showModal(
    VerificarFacturaModal,
    {},
    {
      title: verificarFacturaText,
      width: 620,
      height: 'auto',
    },
  )) as VerificarFacturaModalResult | { result: typeof messageBoxResult.cancel };

  if (!modalResult || (modalResult as { result: string }).result !== messageBoxResult.ok) {
    return;
  }

  const { conforme, observaciones, file } = modalResult as VerificarFacturaModalResult;

  let tempUrlFacturaPropia: string | null = null;
  if (file) {
    try {
      tempUrlFacturaPropia = await api.callStandardApi("postDocumentoTemp", { showLoading: false }, file.name, file);
      model.RutaTemporalFacturaPropia = tempUrlFacturaPropia;
    } catch {
      toastError(intl.i18n.t('datos_factura.errores.factura_propia'));
      return;
    }
  } else {
    model.RutaTemporalFacturaPropia = null;
  }

  try {
    const idFactura = await api.callStandardApi("createFactura", { showLoading: true }, model as CreateFacturaModel);

    if (!conforme) {
      const ticket = CreateTicket.CreateFacturaTicket(idFactura);
      ticket.Asunto = intl.i18n.t('datos_factura.verificar_modal.ticket_asunto');
      ticket.Mensaje.Mensaje = observaciones;
      
      try {
        await api.callStandardApi("createTicket", { showLoading: true }, ticket);
        toastSuccess(intl.i18n.t('datos_factura.verificar_modal.creacion_ticket_exito'));
      } catch {
        toastError(intl.i18n.t('datos_factura.verificar_modal.creacion_ticket_error'));
      }
    }

    emit('facturaCreada');
    toastSuccess(intl.i18n.t('datos_factura.form.creacion_exito'));
  } catch (e: any) {
    if (e instanceof ApiError && e.details?.errorList.length === 1 && [INVOICE_WITH_DUPLICATED_CODE, INVOICE_MISSING_DECOMMISSION_OPERATIONS].includes(e.details.errorList[0].Code))
      toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`))
    else throw e;
  }
}

const optGenerarDescargarFactura = computed(() => { return {
  ...primaryButtonProps(),
  text: `${intl.i18n.t('datos_factura.form.btn_generar_factura')}`,
  width: "100%",
  onClick: generarYDescargarFactura,
  disabled: esGenerarDisabled.value
}});


const optVerificarFactura = computed(() => { return {
  ...primaryButtonProps(),
  text: verificarFacturaText,
  width: "100%",
  onClick: verificarFactura,
  disabled: esVerificarDisabled.value
}});

const verificarFacturaText = `${intl.i18n.t('datos_factura.form.btn_verificar_factura')} ${props.esAutofactura 
? intl.i18n.t('datos_factura.form.autofactura') 
: intl.i18n.t('datos_factura.form.factura')}`;

</script>

<style lang="scss" scoped>
.mensaje-informativo {
  margin-bottom: 16px;

  i {
    margin-right: 6px;
  }
}

.dx-group-item .dx-field-item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.dx-label-h-align .dx-field-item-content)  {
  width: inherit !important; 
}
</style>